import React from "react";
import { Link } from 'react-router-dom';
import { countryCodeToName } from "../../../../../global_functions/global";

export const Financials = ({ financialDetails }) => {
  const date = new Date(financialDetails?.financial_year_end);
  const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sept", "Oct", "Nov", "Dec"];

  const monthName = monthNames[date.getMonth()];

  function ordinalSuffix(num) {
    if (num % 10 == 1 && num % 100 != 11) {
      return num + "st";
    }
    if (num % 10 == 2 && num % 100 != 12) {
      return num + "nd";
    }
    if (num % 10 == 3 && num % 100 != 13) {
      return num + "rd";
    }
    return num + "th";
  }

  const navigateToPage = (id) => {
    window.open(`/search/${id}`, '_blank');
  }

  const dayWithSuffix = ordinalSuffix(date.getDate());

  return (
    (financialDetails?.last_audited || financialDetails?.audit_firm_company || financialDetails?.country) && <div className="bg-white p-6 rounded-xl flex flex-col gap-8">
      <div>
        <h3 className="text-start text-f18 font-semibold">Financials</h3>
      </div>

      <div className="vat flex justify-between p-6 rounded-xl flex-col sm:flex-row gap-4">
        <div className="text-start">
          <p className=" text-f16 sm:text-f18  text-slate">
            Financial Year End
          </p>
          <span className="text-f12 sm:text-f14  text-slate">
            {dayWithSuffix} {monthName}
          </span>
        </div>
        <div className="text-start">
          <p className="text-f16 sm:text-f18 text-slate">Last Audited</p>
          <span className="text-f12 sm:text-f14 text-slate">
            {financialDetails?.last_audited}
          </span>
        </div>
        <div className="text-start">
          <p className="text-f16 sm:text-f18   text-slate">Audit Firm</p>
          <button onClick={() => financialDetails?.audit_firm_companyID ? navigateToPage(financialDetails?.audit_firm_companyID) : null}
            className={`text-f12 sm:text-f14  text-slate capitalize ${financialDetails?.audit_firm_companyID ? "underline cursor-pointer" : "cursor-default"}`}
            target="_blank">
            {financialDetails?.audit_firm_company || financialDetails?.audit_firm_name}
          </button>
        </div>
        <div className="flex sm:gap-24">
          <div className="text-start">
            <p className="text-f16 sm:text-f18   text-slate">State</p>
            <span className="text-f12 sm:text-f14  text-slate capitalize">
              {financialDetails?.state}
            </span>
          </div>
          <div className="text-start">
            <p className="text-f16 sm:text-f18   text-slate">Country</p>
            <span className="text-f12 sm:text-f14  text-slate capitalize">
              {countryCodeToName(financialDetails?.country)}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};
